import { styled } from '@mui/material';

// eslint-disable-next-line import/prefer-default-export
export const Wrapper = styled('div')(({ theme }) => ({
	borderRadius: '16px',

	[theme.breakpoints.down('sm')]: {
		padding: '8px',
	},
}));
